module.exports = __webpack_public_path__ + "fonts/Gilroy-Black.d59719bc.ttf";